
import inMemoryJWT from '../auth/inMemoryJwt';
import Swal from 'sweetalert2';
import { urlServer } from '../config/GlobalConstant'
import socketLogic from '../sockets/sockets';
import localStorage from '../utils/hooks/useLocalStorage';

//authentication actions
export const otherAction = (history) => async dispatch => {
    const accessToken = inMemoryJWT.getToken()
    if (accessToken) {
        await fetch(`${urlServer}api/album/create`, {
            withCredentials: true,
            credentials: 'include',
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            headers: {
                'Cookie': document.Cookie,
                'Content-Type': 'application/json',
                'Authorization': `bearer ${accessToken}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            },
            body: JSON.stringify({
                name: "Fotos de Subidas",
                quantity: 0,
                description: "hola cookie"
            }) // body data type must match "Content-Type" header      
        })
            .then(response => response.json())
            .then(respJson => {
                console.log()
            })
            .catch(error => {
                console.log()
            })
    }
    else {
        history.push('/')
    }
}


export const getRefreshedToken = () => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/kento`, {
        withCredentials: true,
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }// body data type must match "Content-Type" header      
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
        })
        .catch(error => {
            console.log()
        })
}

export const logout = (history) => dispatch => {

    console.log()
    dispatch({ type: "USER_LOGOUT" })

    /*  await fetch(`${urlServer}api/logout`, {
         method: 'POST',
         withCredentials: true,
         credentials: 'include',
         headers: {
             'Content-Type': 'application/json',
             'Authorization': `bearer ${inMemoryJWT.getToken()}`
             // 'Content-Type': 'application/x-www-form-urlencoded',
         },
 
     })
         .then(response => response.json())
         .then(respJson => { */
    socketLogic.userDisconnect(localStorage().getItem('idProfile'))
    inMemoryJWT.setToken(null)
    localStorage().clear()
    inMemoryJWT.ereaseToken();
    history.push('/Login')
    //    console.log()
    /*})
     .catch(error => {
        console.log()
    }) */
}
export const changeProfile = (history) => async dispatch => {
    await fetch(`${urlServer}users/change-profile`, {
        withCredentials: true,
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }// body data type must match "Content-Type" header      
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {
                console.log();
                
                localStorage().setItem("typeProfile", respJson.data.rolInfo.type)
                localStorage().setItem("idProfile", respJson.data.rolInfo._id)
                let picture
                if(respJson.data.rolInfo.picture){
                    picture = respJson.data.rolInfo.picture.url ? respJson.data.rolInfo.picture.url.small ? respJson.data.rolInfo.picture.url.small : respJson.data.rolInfo.picture.url.origin : respJson.data.rolInfo.picture;
                    localStorage().setItem("picturProfile", picture)
                }else{
                    picture = ""
                
                }

              

                inMemoryJWT.setToken(respJson.data.token.token)
                history.go(0)
            }else{
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000
                })
                Toast.fire({
                    icon:'error',
                    title:"Debes cerrar sesión e iniciarla de nuevo para poder realizar el cambio"
                })
            }

        })
        .catch(error => {
            console.log()
        })

}



export const deleteUser = (id, history) => async dispatch => {

    await fetch(`${urlServer}api/user/delete-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            id: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success)
                dispatch(logout(history))
        })
        .catch(error => {
            console.log()
        })
}
